<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div v-if="updatedShowRegForm">
                    <h2>Your basket is empty</h2>
                    <p>You currently have no tyres in your basket. Please use the form below to begin.</p>
                    <div class="mb-4">
                        <slimline-reg-size-form
                            :postcode="postcode"
                            :options="sizeOptions"
                            :image-base-path="imageBasePath"
                        >
                        </slimline-reg-size-form>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-8 pb-3">
                        <div v-if="inlineHeading && !updatedShowRegForm">
                            <h2 class="h1 text-dark mb-3 d-block">Your basket</h2>
                        </div>
                        <basket-upsells
                            :fitter="updatedBasket?.fitter_id"
                            :basket="updatedBasket"
                            :image-base-path="imageBasePath"
                            :fuel-env="fuelEnv"
                            :link-colour="linkColour"
                        ></basket-upsells>
                        <!-- Only show delivery switch if fitter is not chosen or home delivery is chosen? -->
                        <template v-if="(!updatedShowRegForm && updatedNavButtonUrl?.includes('choose-fitter')) || updatedBasket.home_delivery"> 
                            <div class="toggle-route-wrapper mb-1 mb-sm-3 mb-sm-0">
                                <div class="row">
                                    <div class="col-12">
                                        <h2 class="h3">No garage selected</h2>
                                        <h3 class="h5 my-3">Confirm your fitting method</h3>
                                        <div class="row">
                                            <div class="col-12 col-md-6 mb-2 mb-md-0">
                                                <div
                                                    :class="{ 'border-primary pe-none' : !updatedBasket.home_delivery }"
                                                    class="card route-toggle"
                                                >
                                                    <label class="card-body cursor-pointer" for="flexSwitchCheckChecked">
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <h4 class="m-0">Fully Fitted</h4>
                                                            <div
                                                                v-if="updatedBasket.home_delivery == false"
                                                                class="text-black bg-primary p-1 fs-12 uppercase rounded"
                                                            >
                                                                Selected
                                                            </div>
                                                        </div>
                                                        <p class="small my-2 mb-0">You can choose mobile or garage fitting at the next step</p>
                                                        <p class="small my-2">
                                                            <i class="fa-solid text-primary fa-check-circle me-1"></i>
                                                            Fitting Included
                                                        </p>
                                                    </label>
                                                </div>
                                            </div>
                                            <div v-if="!nonTyrePurchase" class="col-12 col-md-6 mb-2 mb-md-0">
                                                <div
                                                    :class="{ 'border-primary pe-none' : updatedBasket.home_delivery}"
                                                    class="card route-toggle"
                                                >
                                                    <label class="card-body cursor-pointer" for="flexSwitchCheckChecked">
                                                        <div class="d-flex align-items-center justify-content-between">
                                                            <h4 class="m-0">Tyre Delivery</h4>
                                                            <div
                                                                v-if="updatedBasket.home_delivery == true"
                                                                class="text-black bg-primary p-1 fs-12 uppercase rounded"
                                                            >
                                                                Selected
                                                            </div>
                                                        </div>
                                                        <p class="small my-2 mb-0">Tyres delivered straight to your door</p>
                                                        <p class="small my-2">
                                                            <i class="fa-solid text-danger fa-times-circle me-1"></i>
                                                            Fitting NOT Included
                                                        </p>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="hidden d-none">
                                                <input class="form-check-input float-start mx-2 cursor-pointer" type="checkbox" role="switch" id="flexSwitchCheckChecked" @change="toggleRoute((toggledHomeDelivery == true ? 1 : 0))"  v-model="toggledHomeDelivery" :checked="toggledHomeDelivery">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                         </template>
                         <div class="row">
                            <div class="col-12">
                                <div v-if="registration?.length > 0 && (!size && updatedBasket?.products?.length == 0)">
                                    <h2 class="h4">You've entered your registration: <span class="uppercase">{{ registration }}</span></h2>
                                    <p>Click the continue button to choose your tyre size.</p>
                                </div>
                                <div v-else-if="size?.length > 0 && updatedBasket?.products == null">
                                    <h2 class="h4">Your chosen tyre size: {{ customTyreUrl }}</h2>
                                    <p>Click the continue button to choose your tyres.</p>
                                </div>
                                <div v-else-if="!updatedBasket?.fitter_id && updatedBasket?.products?.length == 0">
                                    <h2 class="h4">Your chosen tyre size: {{ customTyreUrl }}</h2>
                                    <p>Click the continue button to choose your tyres.</p>
                                </div>
                            </div>
                            <br class="d-none d-lg-block">
                         </div>
                    </div>
                    <div class="col-12 col-lg-4" v-if="!updatedShowRegForm">
                        <basket
                            :fitter="updatedBasket.fitter_id"
                            :basket="updatedBasket"
                            :button-url="updatedNavButtonUrl"
                            :button-text="updatedNavButtonText"
                            :price-bg-colour="priceBgColour"
                            :link-colour="linkColour"
                        ></basket>
                    </div>
                    <div class="col-12">
                        <a v-if="updatedNavButtonUrl" :href="updatedNavButtonUrl" class="d-block d-lg-none col-12 btn btn-primary mt-2 mb-3">{{ updatedNavButtonText }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import url_filters from '@shared/mixins/url_filters';
    export default {
        mixins: [
            url_filters
        ],
        emits: [
            'routeToggled'
        ],
        props: [
            'steps',
            'currentStep',
            'size',
            'showRegForm',
            'navButton',
            'basket',
            'sizeOptions',
            'homeDelivery',
            'sizeUrl',
            'customTyreUrl',
            'registration',
            'imageBasePath',
            'postcode',
            'fuelEnv',
            'priceBgColour',
            'inlineHeading',
            'linkColour',
            'tyreSizeParentPage',
            'nonTyrePurchase'
        ],
        data() {
            return {
                updatedNavButton: this.navButton,
                updatedNavButtonUrl: this.navButton.url ? this.navButton.url : '',
                updatedNavButtonText: this.navButton.text ? this.navButton.text : '',
                toggledHomeDelivery: this.homeDelivery == 1 ? true : false,
                updatedBasket: this.basket,
                updatedShowRegForm: this.showRegForm
            }
        },
        provide() {
            return {
                'sizeUrl': (this.tyreSizeParentPage ? '/tyre-sizes/' : '') + this.sizeUrl
            }
        },
        mounted() {
            this.emitter.on('updateBasket', data => {
                this.updatedBasket = data;
                if(data?.button?.show_registration_size_form) {
                    this.updatedShowRegForm = data.button.show_registration_size_form;
                }
            });
            this.emitter.on('updateNavButton', data => {
                this.updatedNavButtonUrl = data.url;
                this.updatedNavButtonText = data.text;
            });
        },
        methods: {
            toggleRoute: function(data) {
                let vm = this;
                this.emitter.emit('isLoading', true);

                axios.post('/ajax/toggle_home_delivery_route/' + data + '/0')
                .then(response => {
                    this.emitter.emit('routeToggled', data);
                    if(response.data.home_delivery == 1) {
                        this.emitter.emit('updateNavButton', {text: 'Continue to checkout', url: 'booking-details'});
                    } else {
                        this.emitter.emit('updateNavButton', {text: 'Choose fitter', url: 'choose-fitter'});
                    }
                    this.emitter.emit('updateBasket', response.data.basket);
                    this.emitter.emit('isLoading', false);

                })
                .catch(error => {
                    this.emitter.emit('isLoading', false);
                    console.error("There was an error!", error);
                });

            }
        }
    }
</script>

<style lang="scss" scoped>
    .route-toggle {
        border-width: 2px;
    }
    .fs-12 {
        font-size: 12px;
    }
</style>